import { render, staticRenderFns } from "./PersonalInfoView.vue?vue&type=template&id=47a2650c&scoped=true"
import script from "./PersonalInfoView.vue?vue&type=script&lang=js"
export * from "./PersonalInfoView.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfoView.vue?vue&type=style&index=0&id=47a2650c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a2650c",
  null
  
)

export default component.exports